import { render, staticRenderFns } from "./updateMainShift.vue?vue&type=template&id=0a16ae71&scoped=true&"
import script from "./updateMainShift.vue?vue&type=script&lang=js&"
export * from "./updateMainShift.vue?vue&type=script&lang=js&"
import style0 from "./updateMainShift.vue?vue&type=style&index=0&id=0a16ae71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a16ae71",
  null
  
)

export default component.exports